import AlignText from './_aligntext';

export default {
  AlignText,
};
